export default __webpack_public_path__ + "static/media/95-1831116.aa7dcf19.png";